import { render, staticRenderFns } from "./Menus.vue?vue&type=template&id=6f9d1b6c"
import script from "./Menus.vue?vue&type=script&lang=ts"
export * from "./Menus.vue?vue&type=script&lang=ts"
import style0 from "./Menus.vue?vue&type=style&index=0&id=6f9d1b6c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports